import React, { useState, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import AppRouts from './routes/AppRouts';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

function App() {
  const [lang, setLang] = useState(() => localStorage.getItem('lang') || 'en');

  // لتبديل اللغة
  const btnLang = () => {
    const newLang = lang === 'en' ? 'ar' : 'en';
    setLang(newLang);
    localStorage.setItem('lang', newLang); 
  };

  useEffect(() => {
    localStorage.setItem('lang', lang);
  }, [lang]);

  return (
    // <BrowserRouter>
      <div className="App" dir={lang === 'ar' ? 'rtl' : 'ltr'}>
        <div className="app-container row m-0 p-0 d-flex justify-content-center align-items-center">
          <AppRouts lang={lang} btnLang={btnLang} />
        </div>
      </div>
    // </BrowserRouter>
  );
}

export default App;
